import { changeScanFor } from 'actions/import';
import SelectRedesign from 'components/Select/SelectRedesign';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getImportScanFor } from 'selectors/import';
import { useSelector } from 'store';

const scanOptions = [
  { value: 'none', label: 'None' },
  { value: 'email', label: 'Email' },
  { value: 'chat', label: 'Chat' },
  { value: 'email-chat', label: 'Email and Chat' },
];

const ImportScanAttachments: React.FC = () => {
  const dispatch = useDispatch();

  const scan = useSelector(getImportScanFor);

  const handleChangeScan = (value: string): void => {
    dispatch(changeScanFor(value));
  };

  return (
    <div className="flex flex-col gap-1 bg-white">
      <div className="flex flex-row">
        <span>Scan attachments for</span>
        <span className="litlingo-red-color">*</span>
      </div>

      <div className="w-88">
        <SelectRedesign onChange={handleChangeScan} options={scanOptions} value={scan} />
      </div>
    </div>
  );
};

export default ImportScanAttachments;
